// reducers/pubsub/process.js

export function processHasErrored(state = false, action) {
  switch (action.type) {
    case 'PROCESS_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function processIsLoading(state = false, action) {
  switch (action.type) {
    case 'PROCESS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function process(state = [], action) {
  switch (action.type) {
    case 'PROCESS_FETCH_DATA_SUCCESS':
      return action.items;
    default:
      return state;
  }
}